module.exports = __webpack_public_path__ + "img/press-10.90b34052.jpeg";